export default __webpack_public_path__ + "static/media/6.9b843371.jpg";